// extracted by mini-css-extract-plugin
module.exports = {"reactivateBtnWrapper":"ReactivateLoadLorry_reactivateBtnWrapper__aQ9w9","reactivateBtn":"ReactivateLoadLorry_reactivateBtn__gk38h"};